interface Dictionary<T> {
  [key: string]: T
}
type Categories =
  | 'Die 25 besten Winterhotels mit 5 Sternen'
  | 'Die 25 besten Winterhotels mit 4 Sternen'
  | 'Die 25 besten Winterhotels mit 3 Sternen'
export const categories: Dictionary<[string, string, string, string]> = {
  '5 Sterne': [
    '#9C1249',
    '#D01962',
    '#202346',
    'Die 25 besten Winterhotels mit 5 Sternen'
  ],
  '4 Sterne': [
    '#A25F15',
    '#D97E00',
    '#202346',
    'Die 25 besten Winterhotels mit 4 Sternen'
  ],
  '3 Sterne': [
    '#217977',
    '#2CA29F',
    '#202346',
    'Die 25 besten Winterhotels mit 3 Sternen'
  ]
}
